import { Warning } from './components/warning';
import { ModeIndicator } from './components/modeIndicator';

export function TrafficLightHud({ trafficLight, modeIndicator }) {
	const specialMode =
		modeIndicator === 'EMERGENCY' || modeIndicator === 'CLEAN';
	return (
		<div className='absolute left-1/2 top-40 flex h-20 min-w-10 -translate-x-1/2 transform bg-[initial]'>
			<div className='left-1/2 flex flex-row'>
				{specialMode ? (
					<ModeIndicator modeIndicator={modeIndicator} />
				) : (
					!!trafficLight && (
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='150'
							viewBox='0 0 195.64 60.9'
							preserveAspectRatio='xMidYMid meet'
						>
							<title>hud traffic signal</title>
							<g id='Layer_2' data-name='Layer 2'>
								<g id='Layer_1-2' data-name='Layer 1'>
									<circle
										fill={trafficLight === 'RED' ? '#FF0000' : 'transparent'}
										cx='30.1'
										cy='30.1'
										r='29.73'
										stroke='#616160'
										strokeMiterlimit='10'
										strokeWidth='0.75px'
									/>
									<circle
										fill={trafficLight === 'YELLOW' ? '#FFFF00' : 'transparent'}
										cx='97.82'
										cy='30.1'
										r='29.73'
										stroke='#616160'
										strokeMiterlimit='10'
										strokeWidth='0.75px'
									/>
									<circle
										fill={trafficLight === 'GREEN' ? '#07FF00' : 'transparent'}
										cx='165.54'
										cy='30.1'
										r='29.73'
										stroke='#616160'
										strokeMiterlimit='10'
										strokeWidth='0.75px'
									/>
								</g>
								{trafficLight === 'UNKNOWN' && <Warning />}
							</g>
						</svg>
					)
				)}
			</div>
		</div>
	);
}
